import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    SelectField
} from 'react-admin';
import { useActiveStatus } from "../../defaults/defaults";

const companyFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Company name" source="company.name" name="company.name" />,
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminCompanyHouseList = () => {
    const statuses = useActiveStatus();
    return(
        <List
            actions={ <ListActions /> }
            filters={ companyFilters } >
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <SelectField
                    source="status"
                    choices={ statuses }
                />
                <ReferenceField
                    source="company"
                    reference="companies"
                    link="edit"
                >
                    <TextField source="name" />
                </ReferenceField>
                <>
                    <ShowButton />
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );
}